<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/report/dailyStatement")
          i.fa.fa-chart-line
          span.ml-1 {{ $t("ui.daily_statement") }}
      b-breadcrumb-item
        router-link(to="/report/transferList")
          i.fa.fa-chart-line
          span.ml-1 {{ $t("ui.transfer_list") }}
  div.row
    div.col-md-12
      div.card
        //- div.card-header
        //-   div.row
        //-     div.col-md-12.mb-1
        //-       div.row
        //-         div.col-md-3.mb-1
        //-           b-input-group(size="sm")
        //-             b-input-group-text(slot="prepend")
        //-               i.icon-user
        //-             DebounceInput(required autofocus type="text" v-model="search" :placeholder="$t('message.search_by_id')")
        //-         div.col-md-2.mb-1
        //-           b-input-group(size="sm")
        //-             b-input-group-text(slot="prepend")
        //-               span {{ $t("ui.date") }}
        //-             date-picker(v-model="date" :config="locale" @input="getTransferList(true)")
        //-         div.col-md-2.mb-1
        //-           b-input-group(size="sm")
        //-             b-input-group-text(slot="prepend")
        //-               span {{ $t('ui.type') }}
        //-             b-form-select(v-model="requestType" @change="getTransferList(true)")
        //-               option(value=99) {{ $t('ui.all') }}
        //-               option(value=0) {{ $t('ui.deposit') }}
        //-               option(value=1) {{ $t("ui.withdrawal") }}
        //-         div.col-md-1.mb-1
        //-           SubmitButton(
        //-             :loading="loading"
        //-             icon="fa fa-search"
        //-             :text="$t('ui.search')"
        //-             type="button"
        //-             @click="getTransferList()"
        //-             variant="success"
        //-             size="sm"
        //-             )
        div.card-body
          div.mb-1
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.sticky-position(width="3%")
                        span #
                      th.sticky-position.sortable(width="15%" @click="sortOrder('member_id')")
                        span(:title="$t('ui.member_id')") {{ $t('ui.member_id') }}
                        i(:class="changeSortKey('member_id')")
                      th.sticky-position.text-right.sortable(width="19%" @click="sortOrder('currency_code')")
                        span(:title="$t('ui.currency')") {{ $t('ui.currency') }}
                        i(:class="changeSortKey('currency_code')")
                      th.sticky-position.text-right.sortable(width="24%" @click="sortOrder('type')")
                        span(:title="$t('ui.type')") {{ $t('ui.type') }}
                        i(:class="changeSortKey('type')")
                      th.sticky-position.text-right.sortable(width="24%" @click="sortOrder('amount')")
                        span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                        i(:class="changeSortKey('amount')")
                      th.sticky-position.text-right.sortable(width="15%" @click="sortOrder('created_date')")
                        span(:title="$t('ui.created_date')") {{ $t('ui.created_date') }}
                        i(:class="changeSortKey('created_date')")
                  tbody.clusterize-content
                    tr(v-if="transferList.length == 0")
                      td(colspan="6").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in transferList")
                      td
                        span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                      td
                        span(:title="item.member_id") {{ item.member_id }}
                      td.text-right
                        span(:title="item.currency_code") {{ item.currency_code }}
                      td.text-right
                        span(:title="item.request_type") {{ item.request_type }}
                      td.text-right
                        span.font-weight-bold(v-if="item.request_type.toUpperCase() == 'DEPOSIT'" :title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                        span.font-weight-bold.text-danger(v-if="item.request_type.toUpperCase() == 'WITHDRAWAL'" :title="$n(item.amount * -1, 'currency')") {{ $n(item.amount * -1, 'currency') }}
                      td.text-right
                        span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  data: () => ({
    loading: false,
    transferList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    date: null,
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    requestType: 99,
    sortKey: "member_id",
    sortType: "asc"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    getRequestType() {
      if (this.requestType == 1)
        return 'WITHDRAWAL';
      else if (this.requestType == 0)
        return 'DEPOSIT';
      else
        return null;
    }
  },
  mounted: function() {
    if (this.$store.getters.transferList.date)
      this.date = this.$store.getters.transferList.date;
    if (this.$store.getters.transferList.request_type)
      this.requestType = this.getRequestTypeCode(this.$store.getters.transferList.request_type);
    if (this.$store.getters.transferList.search_id)
      this.search = this.$store.getters.transferList.search_id;

    if (this.$store.getters.transferList.target_account_id)
      this.getTransferList(true);
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getTransferList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getRequestTypeCode(name) {
      if (name == 'DEPOSIT')
        return 0;
      else if (name == 'WITHDRAWAL')
        return 1;

      return 99;
    },
    getTransferList: function(isSearch) {
      let url = config.transferListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        source_account_id: this.$store.getters.accountId,
        target_account_id: this.$store.getters.transferList.target_account_id,
        working_date: this.date,
        request_type: this.getRequestType,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      if (this.search.trim() != '')
        json.search_id = this.search;

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.transferList = response.data.dt;
                this.totalRow = response.data.dt.length > 0 ? this.transferList[0]["totalrows"] : 0;
              } else {
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getTransferList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getTransferList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>